import { Grid, Link, Typography } from "@mui/material";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { SP_URL } from "../../constants";

export function ContactConfirmPage() {
  const text = useAppSelector(selectText);

  return (
    <Grid container spacing={2} alignItems={"center"} justifyContent={"center"}>
      <Grid item xs={10} xl={10} sx={{}}>
        <Typography component="h1" variant="h3" textAlign={"center"}>
          {text.contactInfoConfirm.par1}
        </Typography>
      </Grid>
      <Grid item xs={10} xl={10} sx={{ textAlign: "center" }}>
        <CheckCircleIcon fontSize="large" />
      </Grid>
      <Grid item xs={10} xl={10} sx={{}}>
        <Typography component="h1" variant="h3" textAlign={"center"}>
          {text.contactInfoConfirm.par2}
        </Typography>
        <br></br>
        <Typography component="h1" variant="h3" textAlign={"center"}>
          <Link target="_blank" href={SP_URL}>
            {text.contactInfoConfirm.par3}
          </Link>
        </Typography>
      </Grid>
    </Grid>
  );
}
